import axios from '@/api/axios';
import {toQueryString} from '@/api/queryString';
import type {
  AdminPaginatedEnvelope,
  AfriexCountryCode,
  AfriexCurrencyCode,
  AfriexTransactionChannel,
  AfriexTransactionProcessor,
  AfriexTransactionType,
} from '@/types';
import type {AfriexQueryParams} from '@/types/AfriexQueryParams';

const commonEndpoint = '/v2/admin/blocked/payment-methods';

export interface BlockedPaymentMethod {
  id?: string;
  country: AfriexCountryCode;
  accountIdentifier: string;
  type: AfriexTransactionChannel;
  reason: string;
  provider?: string;
  createdAt?: string;
}

export type BlockedPaymentMethodResponse = AdminPaginatedEnvelope<
  BlockedPaymentMethod[]
>;
export type BlockedPaymentMethodFilters = AfriexQueryParams &
  Pick<BlockedPaymentMethod, 'accountIdentifier'>;

export type UpdateProcessorRequest = {
  currency: AfriexCurrencyCode;
  type: AfriexTransactionType;
  paymentMethodName: AfriexTransactionProcessor;
};

export const blockedPaymentMethodService = {
  getList: async (
    filters: BlockedPaymentMethodFilters,
  ): Promise<BlockedPaymentMethodResponse> => {
    const params = {page: 0, limit: 10, ...filters};
    const url = `${commonEndpoint}?${toQueryString(params)}`;
    const response = await axios.get<BlockedPaymentMethodResponse>(url);
    return response.data;
  },

  removeOne: async (id: string): Promise<void> => {
    const response = await axios.delete<void>(commonEndpoint + `/${id}`);
    return response.data;
  },
  saveOne: async (
    body: BlockedPaymentMethod,
  ): Promise<BlockedPaymentMethod> => {
    const response = await axios.post<BlockedPaymentMethod>(
      commonEndpoint,
      body,
    );
    return response.data;
  },
};
